
function stickHeader () {
    const header = document.querySelector(".site-header") as HTMLElement
    const isScrolled = window.pageYOffset > 5

    if (header) {
        if (isScrolled) {
            document.body.classList.add("sticked-header")
        } else {
            document.body.classList.remove("sticked-header")
        }
    }
}

function menuItemToggle () {
    const langSelected = document.querySelector(".site-header__lang") as HTMLElement
    const navigationDropdownToggler = document.querySelector(".site-header__navigation-dropdown") as HTMLElement

    if (langSelected) {
        langSelected.addEventListener("click", (ev) => {
            langSelected.classList.toggle("active")
            ev.stopPropagation()
        })

        langSelected.addEventListener("mouseleave", () => {
            langSelected.classList.remove("active")
        })
    }

    if (navigationDropdownToggler) {
        navigationDropdownToggler.addEventListener("click", (ev) => {
            navigationDropdownToggler.classList.toggle("active")
            ev.stopPropagation()
        })

        navigationDropdownToggler.addEventListener("mouseleave", () => {
            navigationDropdownToggler.classList.remove("active")
        })
    }

    if (navigationDropdownToggler && langSelected) {
        document.body.addEventListener("click", () => {
            langSelected.classList.remove("active")
            navigationDropdownToggler.classList.remove("active")
        })
    }
}

function headerMobileToggle () {
    const btn = document.querySelector(".site-header__hamburger") as HTMLElement
    const header = document.querySelector(".site-header") as HTMLElement

    if (btn && header) {
        btn.addEventListener("click", () => {
            btn.classList.toggle("active")
            header.classList.toggle("active")
            document.body.classList.toggle("remove-scroll")
        })

        window.addEventListener("resize", () => {
            if (window.innerWidth > 767) {
                btn.classList.remove("active")
                header.classList.remove("active")
                document.body.classList.remove("remove-scroll")
            }
        })
    }
}

export const handleHeaderSripts = () => {
    window.addEventListener("scroll", () => {
        stickHeader()
    })

    menuItemToggle()
    headerMobileToggle()
}
